import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams, Link, Navigate } from 'react-router-dom';
import { blogData } from '../data/blogData';
import AOS from 'aos';
import 'aos/dist/aos.css';

function BlogDetay() {
  const { slug } = useParams();
  const post = blogData.find((item) => item.slug === slug);

  // AOS ANİMASYONLARINI BAŞLAT VE BAŞLIĞI ZORLA GÜNCELLE
  useEffect(() => {
    if (post) {
      // --- İŞTE O DİNAMİK SEKME İSMİNİ ÇAKAN KOD ---
      document.title = `${post.baslik} | Ankara Merkez Teknik`;
    }

    window.scrollTo(0, 0); // Sayfa değişince en üste atar
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
    });
  }, [slug, post]); // slug veya post değiştiğinde (başka yazıya geçilirse) tetiklenir

  if (!post) return <Navigate to="/blog" />;

  // --- DİNAMİK GOOGLE MAKALE ŞEMASI (JSON-LD) ---
  const articleSchemaData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.baslik,
    "description": post.ozet,
    "datePublished": post.tarih,
    "author": {
      "@type": "Organization",
      "name": "Ankara Merkez Teknik Uzman Kadrosu"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Ankara Merkez Teknik",
      "logo": {
        "@type": "ImageObject",
        "url": "https://ankaramerkezteknik.com.tr/logo.png"
      }
    }
  };

  return (
    <div className="blog-detail-master-wrapper">
      <Helmet>
        {/* Helmet içinde de durması SEO için iyidir */}
        <title>{post.baslik} | Ankara Merkez Teknik</title>
        <meta name="description" content={post.ozet} />
        <script type="application/ld+json">
          {JSON.stringify(articleSchemaData)}
        </script>
      </Helmet>

      <div className="blog-detail-container">
        
        {/* SOL: ZENGİN İÇERİK ALANI */}
        <article className="blog-article-main" data-aos="fade-up">
          
          <header className="article-header">
            <div className="article-badges">
              <span className="badge-tech">TEKNİK REHBER</span>
              <span className="badge-time">⏱️ 5 Dakika Okuma</span>
            </div>
            <h1>{post.baslik}</h1>
            <div className="article-meta-info">
              <span className="meta-item">🗓️ {post.tarih}</span>
              <span className="meta-item">✍️ Uzman Teknisyen Kadrosu</span>
            </div>
          </header>

          <div className="cyber-line-divider" style={{margin: '30px 0'}}></div>
          
          <div 
            className="article-rich-content"
            dangerouslySetInnerHTML={{ __html: post.icerik }}
          ></div>

          <div className="article-help-card" data-aos="zoom-in">
            <h3>Bu Bilgiler Yeterli Gelmedi mi?</h3>
            <p>Arızanız daha karmaşıksa, cihazınıza zarar vermeden uzman ekibimizi arayabilirsiniz. <strong>Ankara'nın her noktasına 30 dakikada ulaşıyoruz.</strong></p>
            <a href="tel:03125810881" className="btn-primary">Hemen Teknik Destek Al</a>
          </div>

          <div className="article-footer-nav">
            <Link to="/blog" className="back-link">← Teknik Bilgi Bankasına Dön</Link>
          </div>
        </article>

        {/* SAĞ: YAPIŞKAN (STICKY) İLETİŞİM ALANI */}
        <aside className="blog-sidebar-fixed" data-aos="fade-left" data-aos-delay="200">
          <div className="sticky-contact-card">
            <div className="card-pulse-icon">📞</div>
            <h3>Acil Teknik Destek</h3>
            <p>Cihazınız mı bozuldu? Hiç beklemeden profesyonel yardım alın.</p>
            
            <div className="sidebar-action-btns">
              <a href="tel:03125810881" className="btn-call-sidebar">Şimdi Ara</a>
              <a href="https://wa.me/903125810881" className="btn-wa-sidebar">WhatsApp Talebi</a>
            </div>

            <ul className="sidebar-trust-list">
              <li>✅ Aynı Gün Yerinde Müdahale</li>
              <li>✅ 1 Yıl Orijinal Parça Garantisi</li>
              <li>✅ Sertifikalı Usta Kadrosu</li>
            </ul>
          </div>
        </aside>

      </div>
    </div>
  );
}

export default BlogDetay;